import { createStructureStatementHandler } from '../../createStructureStatementHandler';
export const createPreviewFieldStmtInstruction = `
#### Add preview field

- Syntax: \`add previewField <field_name> in <preview_name>;\`
- Example: \`add previewField name in OptionPreview;\`
- Example: \`add previewField category.name in VariantPreview;\` (Use \`.property_name\` when accessing specific attributes within a related entity is required.)
`;
export const stmtAddPreviewField = ({ previewFieldName, previewName }) => {
    return `add previewField ${previewFieldName} in ${previewName};`;
};
export const addPreviewFieldHandler = createStructureStatementHandler({
    type: 'add previewField',
    parse: line => {
        const match = /^add previewField (?<previewFieldName>[\w.]+) in (?<previewName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'add previewField',
                previewFieldName: match.groups.previewFieldName,
                previewName: match.groups.previewName,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.addPreviewField({
                previewFieldName: stmt.previewFieldName,
                previewName: stmt.previewName,
            });
        });
    },
});
//# sourceMappingURL=AddPreviewFieldStmt.js.map